var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgeSearchEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 92,
    viewBox: "0 0 287 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2667_12346)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 31,
    rx: 5,
    transform: "matrix(1 0 0 -1 64 86)",
    fill: "white",
    fillOpacity: 0.77,
    style: {
      mixBlendMode: "luminosity"
    },
    shapeRendering: "crispEdges"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 158,
    height: 30,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 64 85)",
    stroke: "url(#paint0_linear_2667_12346)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2667_12346)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 207,
    height: 41,
    rx: 5,
    transform: "matrix(1 0 0 -1 40 73)",
    fill: "white",
    fillOpacity: 0.77,
    style: {
      mixBlendMode: "luminosity"
    },
    shapeRendering: "crispEdges"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 206,
    height: 40,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 40 72)",
    stroke: "url(#paint1_linear_2667_12346)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2667_12346)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 53,
    rx: 5,
    transform: "matrix(1 0 0 -1 6 59)",
    fill: "white",
    fillOpacity: 0.77,
    style: {
      mixBlendMode: "luminosity"
    },
    shapeRendering: "crispEdges"
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 274,
    height: 52,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 6 58)",
    stroke: "url(#paint2_linear_2667_12346)",
    shapeRendering: "crispEdges"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 49,
    y: 17,
    width: 87,
    height: 7,
    rx: 3.5,
    fill: "#D0D4E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 49,
    y: 32,
    width: 215,
    height: 5,
    rx: 2.5,
    fill: "#D0D4E8",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 49,
    y: 41,
    width: 136,
    height: 5,
    rx: 2.5,
    fill: "#D0D4E8",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66,
    clipPath: "url(#clip0_2667_12346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 22C34.7652 22 35.5015 22.2923 36.0583 22.8173C36.615 23.3422 36.9501 24.0601 36.995 24.824L37 25V37C37 37.7652 36.7077 38.5015 36.1827 39.0583C35.6578 39.615 34.9399 39.9501 34.176 39.995L34 40H20C19.2348 40 18.4985 39.7077 17.9417 39.1827C17.385 38.6578 17.0499 37.9399 17.005 37.176L17 37V25C17 24.2348 17.2923 23.4985 17.8173 22.9417C18.3422 22.385 19.0601 22.0499 19.824 22.005L20 22H34ZM32 34H22L21.883 34.007C21.64 34.0359 21.4159 34.153 21.2534 34.336C21.0909 34.519 21.0011 34.7552 21.0011 35C21.0011 35.2448 21.0909 35.481 21.2534 35.664C21.4159 35.847 21.64 35.9641 21.883 35.993L22 36H32L32.117 35.993C32.3601 35.9641 32.5841 35.847 32.7466 35.664C32.9091 35.481 32.9989 35.2448 32.9989 35C32.9989 34.7552 32.9091 34.519 32.7466 34.336C32.5841 34.153 32.3601 34.0359 32.117 34.007L32 34ZM32 30H22L21.883 30.007C21.64 30.0359 21.4159 30.153 21.2534 30.336C21.0909 30.519 21.0011 30.7552 21.0011 31C21.0011 31.2448 21.0909 31.481 21.2534 31.664C21.4159 31.847 21.64 31.9641 21.883 31.993L22 32H32L32.117 31.993C32.3601 31.9641 32.5841 31.847 32.7466 31.664C32.9091 31.481 32.9989 31.2448 32.9989 31C32.9989 30.7552 32.9091 30.519 32.7466 30.336C32.5841 30.153 32.3601 30.0359 32.117 30.007L32 30ZM32 26H22L21.883 26.007C21.64 26.0359 21.4159 26.153 21.2534 26.336C21.0909 26.519 21.0011 26.7552 21.0011 27C21.0011 27.2448 21.0909 27.481 21.2534 27.664C21.4159 27.847 21.64 27.9641 21.883 27.993L22 28H32L32.117 27.993C32.3601 27.9641 32.5841 27.847 32.7466 27.664C32.9091 27.481 32.9989 27.2448 32.9989 27C32.9989 26.7552 32.9091 26.519 32.7466 26.336C32.5841 26.153 32.3601 26.0359 32.117 26.007L32 26Z",
    fill: "#D0D4E8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2667_12346",
    x: -36,
    y: -45,
    width: 359,
    height: 231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.790462 0 0 0 0 0.790462 0 0 0 0 0.790462 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2667_12346"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2667_12346",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2667_12346",
    x: -60,
    y: -68,
    width: 407,
    height: 241,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.790462 0 0 0 0 0.790462 0 0 0 0 0.790462 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2667_12346"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2667_12346",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2667_12346",
    x: -94,
    y: -94,
    width: 475,
    height: 253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.790462 0 0 0 0 0.790462 0 0 0 0 0.790462 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2667_12346"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2667_12346",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2667_12346",
    x1: 11.1387,
    y1: -0.0000068733,
    x2: 14.5373,
    y2: 40.1295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405687,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574372,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2667_12346",
    x1: 14.5014,
    y1: -0.00000909049,
    x2: 19.0666,
    y2: 53.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405687,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574372,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2667_12346",
    x1: 19.2651,
    y1: -0.0000117511,
    x2: 25.0097,
    y2: 68.6197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405687,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574372,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2667_12346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeSearchEmpty);
export default __webpack_public_path__ + "static/media/knowledge-search-empty.8f11fc3577eaf1aa14bcf25e48f2c207.svg";
export { ForwardRef as ReactComponent };